export enum KeyCodeType {
  NumpadEnter = 'NumpadEnter',
  Enter = 'Enter',
  ESC = 'Esc',
}

export enum InputEventType {
  insertLineBreak = 'insertLineBreak',
}
